import { formatUIDate } from 'utils/helpers'

export const toTableRowItems = (items: any[]) =>
  items.map(item => ({
    id: item.id,
    reportNo: item.reportNo ?? '',
    storeName: item.storeName ?? '',
    creationDate: formatUIDate(item.creationDate),
    wasteCategoryNames: item.wasteCategoryNames ?? [],
    categoryId: item.wasteCategoryId ?? 0,
    carrier: item.carrier ?? '',
    companyName: item.companyName ?? '',
    isHandedOver: item.isHandedOver,
    documentNo: item.documentNo
  }))
